<template>
  <div class="vehicleId-box">
    <div class="vehicleId-control">
      <div class="vehicle-side">
        <div class="vehicle-side-box">
          <CameraInfo />
        </div>
        <div class="vehicle-side-box">
          <PoliceInfo />
        </div>
        <div class="vehicle-side-box">
          <PoliceType />
        </div>
      </div>
      <div class="vehicle-middle">
        <div class="vehicle-middle-videl">
          <VideoBox :devices="devices" />
        </div>
        <div class="vehicle-middle-box">
          <SnapBox />
        </div>
      </div>
      <div class="vehicle-side">
        <div class="vehicle-side-chart">
          <CountBar />
        </div>
        <div class="vehicle-side-chart">
          <CountLine />
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import { mapState } from 'vuex'
import CameraInfo from './CameraInfo'
import PoliceInfo from './policeInfo'
import PoliceType from './policeType'
import VideoBox from './video'
import SnapBox from './snap'
import CountBar from './countBar'
import CountLine from './countLine'
export default {
  name: 'Home',
  components: {
    CameraInfo,
    PoliceInfo,
    PoliceType,
    VideoBox,
    SnapBox,
    CountBar,
    CountLine,
  },
  props: {
  },
  computed: {
    ...mapState('group', ['selectedNode', 'selectedDevices']),
    ...mapState('cmd', ['windowOnResize']),
    ...mapState('common', ['productCodes', 'powerBoxTypes', 'mapCenter']),
  },
  data() {
    return {
      devices: [],
    }
  },
  watch: {
    selectedNode() {
      this.getVideos();
    },
  },
  mounted: function () {
    this.getVideos();
  },
  methods: {
    getVideos: function () {
      let poleId = 0, groupId = 0;
      if(this.selectedNode.type != this.productCodes.station){
        groupId = this.selectedNode.id;
      }else{
        poleId = this.selectedNode.poleId;
      }
      this.$axios.post(`//${this.domains.trans}/pole/config/QueryCameraList`, {groupId, poleId}).then(res => {
        if (res.code != 0) {
          // this.$Message.error(res.data);
          return;
        }
        res.data.map(p => {
          if(!p.content){
            p.content = {};
          }
          if(!p.content.tasks){
            p.content.tasks = [];
          }
        })
        this.$set(this, 'devices', res.data);
      })
    },
  }
}
</script>
<style scoped>
.vehicleId-box {
  height: 790px;
  overflow-y: revert;
}
.vehicleId-control {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: initial;
  justify-content: space-between;
}
.vehicle-side {
  width: 390px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.vehicle-side-box {
  width: 100%;
  height: calc((100% - 30px) / 3);
  background: #ffffff;
  border-radius: 10px;
}
.vehicle-side-chart {
  width: 100%;
  height: calc((100% - 15px) / 2);
  background: #ffffff;
  border-radius: 10px;
}

.vehicle-middle {
  width: calc(100% - 820px);
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.vehicle-middle-videl {
  width: 100%;
  height: calc(100% - (100% - 30px) / 3 - 15px);
  border-radius: 10px;
}
.vehicle-middle-box {
  width: 100%;
  height: calc((100% - 30px) / 3);
  border-radius: 10px;
}
</style>
